/**
 * Skincare Section JavaScript
 * Handles navigation, video controls, routine toggles, and Swiper initialization
 */

// Global variables for Swiper instances
const swiperInstances = {};

/**
 * Initialize Swiper for a specific section
 * @param {string} sectionId - The ID of the section (e.g., '36667')
 * @param {Array} slideTitles - Array of slide titles
 * @param {Array} routineIds - Array of routine IDs corresponding to slides
 */
function initSwiperForSection(sectionId, slideTitles, routineIds) {
    const swiperKey = `swiper_${sectionId}`;
    // La columna derecha ahora muestra tarjetas de packs (sin slider): solo se inicia si existe
    if (typeof Swiper === 'undefined' || !document.querySelector(`#b${sectionId} .steps`)) return;
    
    swiperInstances[swiperKey] = new Swiper(`#b${sectionId} .steps`, {
        fadeEffect: { crossFade: true },
        virtualTranslate: true,
        autoplay: false,
        autoHeight: true,
        speed: 1000,
        slidersPerView: 1,
        effect: "fade",
        pagination: {
            el: `#b${sectionId} .custom-bullets`,
            clickable: true,
            renderBullet: function(index, className) {
                return `<span onclick="toggleRoutine(${sectionId}, ${routineIds[index]});" class="${className}">${slideTitles[index]}</span>`;
            }
        }
    });
}

/**
 * Navigate to a specific section when clicking on main navigation
 * @param {string} id - The section ID
 */
function navigate_to(id) {
    const element = $('#b' + id);
    if (element && element.length) {
        const pos = element.offset().top - 75;
        
        // Animated scrolling
        $("body, html").animate({ scrollTop: pos }, 800, 'swing');
    }
    
    // Update active state
    $('.skincare > .custom-bullets span').removeClass('active');
    $('#h' + id).addClass('active');
}

/**
 * Toggle between different routines in a section
 * @param {string} body_id - The section ID
 * @param {string} rutina - The routine ID to show
 */
function toggleRoutine(body_id, rutina) {
    // Pause all videos in this section
    $('#b' + body_id + ' video').each(function() {
        if (!this.paused) {
            this.pause();
            // Restore play button icon
            $(this).siblings('.play').html('<i class="fa-solid fa-play"></i>');
        }
    });
    
    // Show selected routine, hide others
    $('#b' + body_id + ' .video').css('display', 'none');
    $('#b' + body_id + ' .video.vid_rut_' + rutina).css('display', 'flex');
}

/**
 * Switch between video tabs within a routine
 * @param {string} body_id - The section ID
 * @param {string} nn - The video number (1, 2, etc.)
 * @param {string} rutina - The routine ID
 */
function videoTab(body_id, nn, rutina) {
    // Update video containers
    const $allVideoContainers = $('#b' + body_id + ' .vid_rut_' + rutina + ' .video_container');
    
    $allVideoContainers.each(function() {
        const $container = $(this);
        const targetId = 'v' + nn + '_r' + rutina;
        
        if ($container.attr('id') === targetId) {
            $container.addClass('active');
        } else {
            $container.removeClass('active');
        }
    });
    
    // Update tab active states
    $('#b' + body_id + ' .vid_rut_' + rutina + ' .tab').removeClass('active');
    $('#b' + body_id + ' .vid_rut_' + rutina + ' .tab' + nn + '_rut' + rutina).addClass('active');
}

/**
 * Toggle play/pause for a video
 * @param {HTMLElement} button - The play/pause button element
 * @param {string} body_id - The section ID
 * @param {string} n - The video number
 * @param {string} rutina - The routine ID
 */
function toggle_play_pause(button, body_id, n, rutina) {
    const videoContainerId = 'v' + n + '_r' + rutina;
    const videoContainer = document.getElementById(videoContainerId);
    
    if (!videoContainer) {
        console.warn(`Video container #${videoContainerId} not found.`);
        return;
    }
    
    const videoElement = videoContainer.querySelector('video');
    
    if (videoElement) {
        if (videoElement.paused) {
            // Play video and pause any other videos in the same routine
            pauseOtherVideos(body_id, rutina, videoContainerId);
            
            videoElement.play()
                .then(() => {
                    button.innerHTML = '<i class="fa-solid fa-pause"></i>';
                })
                .catch(error => {
                    console.error('Error playing video:', error);
                });
        } else {
            videoElement.pause();
            button.innerHTML = '<i class="fa-solid fa-play"></i>';
        }
    } else {
        console.warn(`No video element found inside #${videoContainerId}.`);
    }
}

/**
 * Pause all videos except the specified one
 * @param {string} body_id - The section ID
 * @param {string} rutina - The routine ID
 * @param {string} activeContainerId - The ID of the video container to keep playing
 */
function pauseOtherVideos(body_id, rutina, activeContainerId) {
    $('#b' + body_id + ' .vid_rut_' + rutina + ' .video_container video').each(function() {
        const video = this;
        const container = video.closest('.video_container');
        
        if (container.id !== activeContainerId && !video.paused) {
            video.pause();
            // Update the corresponding button
            $(container).find('.play').html('<i class="fa-solid fa-play"></i>');
        }
    });
}

/**
 * Play a specific video programmatically
 * @param {string} body_id - The section ID
 * @param {string} n - The video number
 * @param {string} rutina - The routine ID
 */
function play_video(body_id, n, rutina) {
    const videoContainerId = 'v' + n + '_r' + rutina;
    const videoContainer = document.getElementById(videoContainerId);
    
    if (videoContainer) {
        const videoElement = videoContainer.querySelector('video');
        if (videoElement) {
            videoElement.play()
                .catch(error => console.error('Error playing video:', error));
        }
    }
}

/**
 * Handle scroll events to update active navigation state
 */
$(window).scroll(function() {
    const windowTop = $(this).scrollTop();
    
    // Update custom bullets active state based on scroll position
    $('.skincare > .custom-bullets span').each(function() {
        const id = $(this).attr('id');
        if (id) {
            const sectionId = id.replace('h', 'b');
            const section = $('#' + sectionId);
            
            if (section.length) {
                const sectionTop = section.offset().top;
                
                if (windowTop >= sectionTop - 180) {
                    $('.skincare > .custom-bullets span').removeClass('active');
                    $(this).addClass('active');
                }
            }
        }
    });
});

/**
 * Update Swiper height on window resize
 */
$(window).resize(function() {
    // Recalculate Swiper heights for better responsiveness
    Object.keys(swiperInstances).forEach(key => {
        if (swiperInstances[key] && swiperInstances[key].update) {
            swiperInstances[key].update();
        }
    });
});

/**
 * Document ready handler
 */
$(document).ready(function() {
    // Adjust top position of sticky navigation
    const headerHeight = $('header').innerHeight() || 112;
    $('.skincare > .custom-bullets').css('top', headerHeight + 'px');
    
    // Add keyboard navigation support
    $(document).keydown(function(e) {
        // Left/Right arrow keys for navigation between main sections
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            const activeBullet = $('.skincare > .custom-bullets span.active');
            let nextBullet;
            
            if (e.key === 'ArrowRight') {
                nextBullet = activeBullet.next();
            } else {
                nextBullet = activeBullet.prev();
            }
            
            if (nextBullet && nextBullet.length) {
                const id = nextBullet.attr('id');
                if (id) {
                    const sectionId = id.replace('h', '');
                    navigate_to(sectionId);
                }
            }
        }
    });
    
    // Initialize all Swipers
    initSwiperForSection('36667', ['RUTINA DE DÍA Y NOCHE'], ['36670']);
    initSwiperForSection('36668', ['RUTINA 1', 'RUTINA 2', 'RUTINA 3'], ['36671', '36672', '36673']);
    initSwiperForSection('36669', ['RUTINA 1', 'RUTINA 2', 'RUTINA 3'], ['36702', '36703', '36704']);
});

/**
 * Marca como activo el botón del selector de rutina (columna izquierda)
 * @param {HTMLElement} el - El botón pulsado
 */
function qwRoutineSwitch(el) {
    $(el).siblings().removeClass('active');
    $(el).addClass('active');
}

// Export functions for global use
window.qwRoutineSwitch = qwRoutineSwitch;
window.navigate_to = navigate_to;
window.toggleRoutine = toggleRoutine;
window.videoTab = videoTab;
window.toggle_play_pause = toggle_play_pause;
window.play_video = play_video;
window.initSwiperForSection = initSwiperForSection;